import React from "react";
import { FiTrendingUp } from "react-icons/fi";

const StudentDashboardCard = ({ title, value, icon: Icon, color }) => {
  return (
    <div className="db-col-12 db-col-sm-6 db-col-lg-3">
      <div className="db-stat-card">
        <div className="db-stat-content">
          <div className="db-stat-text">
            <h3 className="db-stat-label">{title}</h3>

            <h2 className="db-stat-value">{value}</h2>

            <div className="db-stat-badge">
              <FiTrendingUp className="db-badge-icon" />
              <span>Live Data</span>
            </div>
          </div>

          <div
            className="db-stat-icon"
            style={{
              backgroundColor: `${color}20`,
              color: color,
            }}
          >
            <Icon size={28} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDashboardCard;